import { useState } from 'react';

export default function useLocationSearchApi({ searchText, setIsLoading, setError }) {
  const [results, setResults] = useState(null);

  function searchLocation() {
    setIsLoading(true);

    if (!searchText.length) {
      setIsLoading(false);
      setError(null);
      return;
    }

    fetch('/api/fetch-text-search', {
      body: JSON.stringify({ searchText }),
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
    })
      .then(response => response.json())
      .then(resData => resData?.data)
      .then(data => {
        if (data?.status !== 'OK') throw new Error('Failed to load data!');
        setResults(data?.results);
      })
      .catch(error => {
        console.log(error);
        setError('Failed to reach google API!');
      })
      .finally(() => setIsLoading(false));
  }

  return {
    results,
    searchLocation,
  };
}
